import { combineReducers, Reducer } from 'redux';
import { DamzState } from '../../types';

import initialization from './initialization';
import counter from './counter';
import drawer from './drawer';
import room from './room';
import roomUnreadState from './roomUnread';
import activity from './global';
import drafts from './drafts';
import storage from './storage';
import settings from './settings';
import denyUserList from './denyUserList';
import damzActions from './damzActions';
import search from './search';
import reactionUsers from './reactionUsers';
import realtime from './realtime';
import altcha from './altcha';

// This type makes sure we do not forget to add a reducer for any slice
// of the store nor can we add extras for non-existing slices.
// Needed because monday (thursday) mornings exist.
type ReducersMapObject = {
  [k in keyof DamzState]: Reducer<any>;
};

const rootReducers: ReducersMapObject = {
  initialization,
  counter,
  drawer,
  room,
  roomUnreadState,
  activity,
  drafts,
  storage,
  settings,
  denyUserList,
  damzActions,
  search,
  reactionUsers,
  realtime,
  altcha,
};

export default combineReducers(rootReducers);
